module.exports = __webpack_public_path__ + "img/icon_map_nzz_c.82d37e8c.png";